import { withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d95856e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["fieldId", "fieldName"]
const _hoisted_2 = { class: "container" }
const _hoisted_3 = {
  key: 0,
  class: "col p-0"
}
const _hoisted_4 = ["fieldName", "fieldLabelName", "value"]
const _hoisted_5 = {
  key: 1,
  class: "col p-0 ellipsis"
}
const _hoisted_6 = {
  key: 1,
  class: "grid-table-cell align-middle noselect subject-property-column"
}
const _hoisted_7 = { class: "container" }
const _hoisted_8 = { class: "row flex-nowrap" }
const _hoisted_9 = { class: "col-sm-auto p-0" }
const _hoisted_10 = { class: "col p-0 ellipsis" }
const _hoisted_11 = { class: "container" }
const _hoisted_12 = { class: "row flex-nowrap" }
const _hoisted_13 = { class: "col-sm-auto initial-badge-container" }
const _hoisted_14 = ["data-bs-original-title", "aria-label"]
const _hoisted_15 = { class: "col-sm-auto p-0" }
const _hoisted_16 = {
  key: 0,
  class: "transfer-text"
}
const _hoisted_17 = ["data-id", "value"]
const _hoisted_18 = { class: "col-sm-auto p-0" }
const _hoisted_19 = ["hidden"]
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = { class: "container" }
const _hoisted_22 = { class: "row flex-nowrap" }
const _hoisted_23 = {
  key: 0,
  class: "col p-0"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "no-property-image fas fa-home" }, null, -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = {
  key: 1,
  class: "col p-0"
}
const _hoisted_27 = ["src"]
const _hoisted_28 = { class: "property-enlarge-container" }
const _hoisted_29 = { class: "col-sm-auto p-0" }
const _hoisted_30 = ["hidden"]
const _hoisted_31 = { class: "container" }
const _hoisted_32 = { class: "row flex-nowrap" }
const _hoisted_33 = { class: "col-sm-auto p-0" }
const _hoisted_34 = {
  key: 0,
  class: "col p-0 ellipsis"
}
const _hoisted_35 = {
  key: 0,
  class: "source-skeleton-row"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "source-skeleton-bar" }, null, -1))
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = {
  key: 1,
  class: "obscure-text"
}
const _hoisted_39 = { class: "col-sm-auto p-0" }
const _hoisted_40 = ["hidden"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isFieldData)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "grid-table-cell align-middle noselect fields-column",
          fieldId: _ctx.fieldId,
          fieldName: _ctx.fieldName
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              class: _normalizeClass(["row flex-nowrap", { 'm-0': _ctx.isRoomLevelField }])
            }, [
              (_ctx.fieldName.includes('BL_BLANK'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("div", {
                      class: _normalizeClass({ 'field-label-content-padded': !_ctx.showRowVisibilityIcon && !_ctx.isSubject })
                    }, [
                      (_ctx.showRowVisibilityIcon)
                        ? (_openBlock(), _createElementBlock("i", {
                            key: 0,
                            class: _normalizeClass(["fas hover me-1", _ctx.rowVisibilityIconClass]),
                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.toggleRowVisibility()), ["stop"]))
                          }, null, 2))
                        : _createCommentVNode("", true),
                      _createTextVNode(_toDisplayString(_ctx.cellDataClone.value) + " : ", 1),
                      _createElementVNode("input", {
                        type: "text",
                        fieldName: _ctx.fieldName,
                        fieldLabelName: _ctx.getFieldLabelName(_ctx.fieldName),
                        class: "additional-custom-input",
                        placeholder: "Field Label...",
                        value: _ctx.getValue(_ctx.fieldName),
                        onKeyup: _cache[1] || (_cache[1] = ($event: any) => (_ctx.additionalFieldName($event, _ctx.getFieldLabelName(_ctx.fieldName))))
                      }, null, 40, _hoisted_4)
                    ], 2)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (_ctx.showRowVisibilityIcon)
                      ? (_openBlock(), _createElementBlock("i", {
                          key: 0,
                          class: _normalizeClass(["fas hover me-1", _ctx.rowVisibilityIconClass]),
                          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.toggleRowVisibility()), ["stop"]))
                        }, null, 2))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", {
                      class: _normalizeClass({ 'field-label-content-padded': !_ctx.showRowVisibilityIcon && !_ctx.isSubject })
                    }, _toDisplayString(_ctx.cellDataClone.value), 3)
                  ]))
            ], 2)
          ])
        ], 8, _hoisted_1))
      : (_ctx.isSubjectProperty && !_ctx.isPhotoRow)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  (_ctx.showConcatenatedValueIcon(_ctx.fieldName))
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        class: "hover s-color-1 launch-popover fas fa-question-circle p-1",
                        onMouseenter: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showConcatenatedValuePopover($event, _ctx.fieldName, _ctx.fieldFriendlyName))),
                        onMouseleave: _cache[4] || (_cache[4] = ($event: any) => (_ctx.hideConcatenatedValuePopover()))
                      }, null, 32))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.cellDataClone.value), 1)
              ])
            ])
          ]))
        : (_ctx.isTransferData && !_ctx.isPhotoRow)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass(["grid-table-cell align-middle noselect transfer-column", { 'transfer-column-with-subject': !_ctx.isSubject }])
            }, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["me-1", [`initial-badge-${String(_ctx.cellDataClone.sourceInitial || '').toLowerCase()}`]]),
                      "data-bs-toggle": "tooltip",
                      "data-bs-placement": "top",
                      "data-bs-original-title": _ctx.getInitialName(_ctx.cellDataClone.sourceInitial),
                      "aria-label": _ctx.getInitialName(_ctx.cellDataClone.sourceInitial)
                    }, null, 10, _hoisted_14)
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    (_ctx.showConcatenatedValueIcon(_ctx.fieldName))
                      ? (_openBlock(), _createElementBlock("i", {
                          key: 0,
                          class: "hover s-color-1 launch-popover fas fa-question-circle p-1",
                          onMouseenter: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showConcatenatedValuePopover($event, _ctx.fieldName, _ctx.fieldFriendlyName))),
                          onMouseleave: _cache[6] || (_cache[6] = ($event: any) => (_ctx.hideConcatenatedValuePopover()))
                        }, null, 32))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", {
                    class: "col p-0 ellipsis",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.startEditingValue()))
                  }, [
                    (!_ctx.isEditing)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.cellDataClone.value), 1))
                      : _createCommentVNode("", true),
                    (_ctx.isEditing)
                      ? (_openBlock(), _createElementBlock("input", {
                          key: 1,
                          "data-id": this.cellId,
                          type: "text",
                          class: "grid-control ut-edit",
                          value: _ctx.editValue,
                          onKeyup: _cache[7] || (_cache[7] = _withKeys(($event: any) => (_ctx.doneEditingValue($event.target.value)), ["enter"])),
                          onBlur: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.doneEditingValue($event.target.value)), ["stop"]))
                        }, null, 40, _hoisted_17))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("i", {
                      class: "fas fa-font me-1 hover",
                      hidden: !_ctx.cellDataClone.fieldRulesApplied,
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.launchFieldRulesModal()))
                    }, null, 8, _hoisted_19),
                    (_ctx.fieldName !== 'MARKETAREA')
                      ? (_openBlock(), _createElementBlock("i", {
                          key: 0,
                          class: _normalizeClass([_ctx.cellDataClone.fieldNotes !== '' ? 'fas fa-comment-alt' : 'far fa-comment-alt', "hover s-color-1 launch-popover"]),
                          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showNotesPopover($event, _ctx.fieldName, _ctx.cellDataClone.friendlyFieldName, _ctx.cellDataClone.fieldNotes)))
                        }, null, 2))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ], 2))
          : (_ctx.isCascadeData)
            ? (_openBlock(), _createElementBlock("div", {
                key: 3,
                innerHTML: _ctx.cellData.value,
                class: "grid-table-cell align-middle noselect cascade-column hover",
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.launchDataPreferenceSettingsModal()))
              }, null, 8, _hoisted_20))
            : (_ctx.isPhotoRow)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 4,
                  class: _normalizeClass(["grid-table-cell align-middle noselect comp-photo", [_ctx.isTransferData ? 'transfer-column' : '', _ctx.isSubjectProperty ? 'subject-property-column' : '', _ctx.isTransferData && !_ctx.isSubject ? 'transfer-column-with-subject' : '', _ctx.hasCompPhoto() && _ctx.cellDataClone.dataSelected ? 'data-selected data-match' : '']])
                }, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      (!_ctx.hasCompPhoto())
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_25))
                        : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            _createElementVNode("img", {
                              src: _ctx.cellDataClone.value,
                              class: "property-image hover",
                              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.isSubjectProperty ? _ctx.photoClick() : _ctx.selectedValue(_ctx.cellDataClone.value, _ctx.cellDataClone.sourceInitial, _ctx.fieldName, _ctx.fieldFriendlyName, _ctx.cellDataClone.sourceInitialIdx)))
                            }, null, 8, _hoisted_27),
                            _createElementVNode("div", _hoisted_28, [
                              _createElementVNode("div", {
                                class: "property-icon",
                                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.photoClick()))
                              })
                            ])
                          ])),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("i", {
                          class: "fas fa-check s-color-1",
                          hidden: !_ctx.hasCompPhoto() || !_ctx.cellDataClone.dataSelected
                        }, null, 8, _hoisted_30),
                        (_ctx.isTransferData)
                          ? (_openBlock(), _createElementBlock("i", {
                              key: 0,
                              class: _normalizeClass([_ctx.cellDataClone.fieldNotes !== '' ? 'fas fa-comment-alt' : 'far fa-comment-alt', "hover s-color-1 launch-popover"]),
                              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.showNotesPopover($event, _ctx.fieldName, _ctx.cellDataClone.friendlyFieldName, _ctx.cellDataClone.fieldNotes)))
                            }, null, 2))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ], 2))
              : (_openBlock(), _createElementBlock("div", {
                  key: 5,
                  class: _normalizeClass(["grid-table-cell align-middle noselect", [!_ctx.cellData.dataMatch ? 'data-mis-match' : '', _ctx.cellDataClone.dataSelected ? 'data-selected data-match' : '', _ctx.cellDataClone.value && !_ctx.cellDataClone.isFakeData ? 'has-cell-value' : '']])
                }, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        (_ctx.showConcatenatedValueIcon(_ctx.fieldName))
                          ? (_openBlock(), _createElementBlock("i", {
                              key: 0,
                              class: "hover s-color-1 launch-popover fas fa-question-circle p-1",
                              onMouseenter: _cache[16] || (_cache[16] = ($event: any) => (_ctx.showConcatenatedValuePopover($event, _ctx.fieldName, _ctx.fieldFriendlyName))),
                              onMouseleave: _cache[17] || (_cache[17] = ($event: any) => (_ctx.hideConcatenatedValuePopover()))
                            }, null, 32))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.cellDataClone.isFakeData)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                            (_ctx.showSourceSkeletonLoader())
                              ? (_openBlock(), _createElementBlock("div", _hoisted_35, _hoisted_37))
                              : (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(_ctx.cellDataClone.value), 1))
                          ]))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "col p-0 ellipsis",
                            onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.selectedValue(_ctx.cellDataClone.value, _ctx.cellDataClone.sourceInitial, _ctx.fieldName, _ctx.fieldFriendlyName, _ctx.cellDataClone.sourceInitialIdx)))
                          }, _toDisplayString(_ctx.cellDataClone.value), 1)),
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("i", {
                          class: "fas fa-check s-color-1",
                          hidden: !_ctx.cellDataClone.dataSelected
                        }, null, 8, _hoisted_40)
                      ])
                    ])
                  ])
                ], 2)),
    (_ctx.modalSuggestFormattingRule.show)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.modalSuggestFormattingRule.component), {
          key: 6,
          onHide: _cache[19] || (_cache[19] = ($event: any) => (_ctx.modalSuggestFormattingRule.show = false)),
          fieldFriendlyName: _ctx.fieldFriendlyName,
          fieldId: _ctx.fieldId,
          originalValue: _ctx.modalSuggestFormattingRule.originalValue,
          newValue: _ctx.modalSuggestFormattingRule.newValue
        }, null, 8, ["fieldFriendlyName", "fieldId", "originalValue", "newValue"]))
      : _createCommentVNode("", true),
    (_ctx.modalConfirmation.show)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.modalConfirmation.component), {
          key: 7,
          message: _ctx.modalConfirmation.message,
          buttons: _ctx.modalConfirmation.buttons,
          modalSize: _ctx.modalConfirmation.size,
          onHide: _cache[20] || (_cache[20] = ($event: any) => (_ctx.modalConfirmation.show = false)),
          includeModalHeader: true,
          title: _ctx.modalConfirmation.title
        }, null, 8, ["message", "buttons", "modalSize", "title"]))
      : _createCommentVNode("", true)
  ], 64))
}